import Phaser from "phaser";
import LoadingScene from "@/games/Kombat-2/scenes/LoadingScene";
import QuestionScene from "@/games/Kombat-2/scenes/QuestionScene";
import PlayScene from "@/games/Kombat-2/scenes/PlayScene";
import LandingScene from "@/games/Kombat-2/scenes/LandingScene";
import Settings from "@/games/Kombat-2/scenes/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      QuestionScene,
      PlayScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
